import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {MatMenuModule} from '@angular/material/menu';
import { CambiarContrasenaComponent } from './cambiar-contrasena/cambiar-contrasena.component';
import { CambiarFotoComponent } from './cambiar-foto/cambiar-foto.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTooltipModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatDatepickerModule,
  MatRadioModule,
  MatCheckboxModule,
  MatSnackBarModule
} from '@angular/material';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatSortModule,
   MatTableModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatSnackBarModule,
    FormsModule, ReactiveFormsModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    CambiarContrasenaComponent,
    CambiarFotoComponent,

  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    MatMenuModule,
    MatProgressBarModule,
    MatSnackBarModule
  ]
})
export class ComponentsModule { }
